"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TabPanel", {
  enumerable: true,
  get: function get() {
    return _tabPanel.TabPanel;
  }
});
exports.Type = exports.Tabs = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _tabPanel = require("./tabPanel");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _useTracking = require("../../hooks/useTracking");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Type;
exports.Type = Type;
(function (Type) {
  Type["noUnderscore"] = "noUnderscore";
  Type["underscore"] = "underscore";
})(Type || (exports.Type = Type = {}));
var Tabs = function Tabs(props) {
  var contentClass = props.contentClass,
    titleClass = props.titleClass,
    titles = props.titles,
    _props$defaultSelecte = props.defaultSelected,
    defaultSelected = _props$defaultSelecte === void 0 ? 0 : _props$defaultSelecte,
    children = props.children,
    className = props.className,
    _props$type = props.type,
    type = _props$type === void 0 ? Type.noUnderscore : _props$type,
    componentTrackingData = props.componentTrackingData;
  var _useState = (0, _react.useState)(defaultSelected),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var domRef = (0, _react.useRef)(null);
  (0, _react.useLayoutEffect)(function () {
    var _domRef$current;
    domRef === null || domRef === void 0 ? void 0 : (_domRef$current = domRef.current) === null || _domRef$current === void 0 ? void 0 : _domRef$current.scrollIntoView({
      block: 'end'
    });
  }, []);
  function onChange(index, title) {
    if (index === selected || title.disabled) {
      return;
    }
    setSelected(index);
  }
  var renderTitle = function renderTitle(title, index) {
    var _useComponentTracking = (0, _useTracking.useComponentTracking)({
        componentTrackingData: componentTrackingData,
        componentData: {
          title: title,
          index: index
        }
      }),
      tracker = _useComponentTracking.tracker,
      tabTracking = _useComponentTracking.result.tab;
    var props = {
      className: (0, _clsx.default)({
        selected__underscope: index === selected && type === Type.underscore,
        selected: index === selected,
        disabled: title.disabled
      }),
      onClick: function onClick() {
        onChange(index, title);
        (tabTracking === null || tabTracking === void 0 ? void 0 : tabTracking.trackingClick) && tracker.click(tabTracking.trackingClick);
      }
    }; // 默认tab到可见区域

    if (index === selected) {
      props.ref = domRef;
    }
    return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({
      key: title.name
    }, props, tabTracking === null || tabTracking === void 0 ? void 0 : tabTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement("span", null, title.name));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('tabs'), className)
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('tabs-title'), titleClass)
  }, titles.map(function (title, index) {
    return renderTitle(title, index);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('tabs-content-wrapper')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('tabs-content'), contentClass)
  }, _react.default.Children.map(children, function (child, index) {
    var show = index === selected;
    var style = {};
    if (!show) {
      style = {
        position: 'absolute',
        left: -9999
      };
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      style: style
    }, child);
  }))));
};
exports.Tabs = Tabs;